module.exports = __webpack_public_path__ + "static/media/mod-intenders.2f4c0967.jpg";


//////////////////
// WEBPACK FOOTER
// ./src/images/portfolio/mod-intenders.jpg
// module id = 334
// module chunks = 0